var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3H5.49996C4.11987 3.00165 3.00162 4.1199 3 5.49996V18.5C3.00165 19.8801 4.1199 20.9983 5.49996 21H18.5C19.8801 20.9983 20.9983 19.8801 21 18.5V5.49996C20.9983 4.11987 19.8801 3.00162 18.5 3ZM20 18.5C19.9991 19.328 19.328 19.9991 18.5001 20H5.49993C4.672 19.9991 4.00086 19.328 4.00002 18.5001V5.49993C4.0009 4.67203 4.67203 4.0009 5.49996 4.00002H18.5001C19.328 4.00086 19.9992 4.672 20 5.49993L20 18.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12C13.5 12.8284 12.8284 13.5001 12 13.5001C11.1716 13.5001 10.4999 12.8284 10.4999 12C10.4999 11.1717 11.1716 10.5 12 10.5C12.8283 10.5 13.5 11.1717 13.5 12ZM18 16.5C18 17.3284 17.3284 18.0001 16.5 18.0001C15.6716 18.0001 14.9999 17.3284 14.9999 16.5C14.9999 15.6717 15.6716 15 16.5 15C17.3283 15 18 15.6717 18 16.5ZM9.00003 16.5C9.00003 17.3284 8.32834 18.0001 7.49999 18.0001C6.67163 18.0001 5.99994 17.3284 5.99994 16.5C5.99994 15.6717 6.67163 15 7.49999 15C8.32834 15 9.00003 15.6717 9.00003 16.5ZM18 7.50005C18 8.32843 17.3284 9.00009 16.5 9.00009C15.6716 9.00009 14.9999 8.3284 14.9999 7.50005C14.9999 6.6717 15.6716 6 16.5 6C17.3283 6 18 6.6717 18 7.50005ZM9.00003 7.50005C9.00003 8.32843 8.32834 9.00009 7.49999 9.00009C6.67163 9.00009 5.99994 8.3284 5.99994 7.50005C5.99994 6.6717 6.67163 6 7.49999 6C8.32834 6 9.00003 6.6717 9.00003 7.50005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardActive);
export default __webpack_public_path__ + "static/media/board_active.51b1d6960d271433f4c2fc5fdf8257b8.svg";
export { ForwardRef as ReactComponent };